module.exports = __webpack_public_path__ + "static/media/10.97617737.JPG";